export const isVatNumberValid = (vatNumber: string) => {
  const pattern1 = /^EU[0-9]{9}$/;
  const pattern2 = /^IM[0-9]{10}$/;
  const pattern3 = /^N[0-9]{10}$/;
  const pattern4 = /^[A-Z0-9\+\*]{1,12}$/;
  if (!vatNumber) return false;
  if (
    !pattern1.test(vatNumber) &&
    !pattern2.test(vatNumber) &&
    !pattern3.test(vatNumber) &&
    !pattern4.test(vatNumber)
  )
    return false;
  return true;
};
